import { render } from "./EnterLicensePlate.vue?vue&type=template&id=68f2132e"
import script from "./EnterLicensePlate.vue?vue&type=script&lang=js"
export * from "./EnterLicensePlate.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./EnterLicensePlate.vue?vue&type=style&index=0&id=68f2132e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/r/Desktop/ev-switch-global/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__